import jwt from 'jwt-decode';

export const readToken = (token: string): AccessToken => jwt(token);
